export enum MaterialRenderSortType {
  opaque = "opaque",
  transparent = "transparent"
}